module.exports = __webpack_public_path__ + "media/application/images/ui/blurred_test_results-ea73cb72e99898ca05a630848ee4ae37.png";